import React, { useEffect } from 'react'
import { useRouter } from 'next/router';
import Header from '../../components/layout/Header/Header';
import Layout from '../../components/layout/Layout/Layout';
import { ReactSVG } from "react-svg"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useMapAssetsContext, loadMapAsset } from '../../context/mapsContext';
import Loading from "../../components/global/Loading";
import ControlButton from "../../components/global/Maps/ControlButton";

const Map = () => {
  const router = useRouter();
  let { slug } = router.query;  

  const {
    state: { loading, mapAssets },
    dispatch,
  } = useMapAssetsContext();

  useEffect(() => {
    if (slug && !mapAssets[slug as string]) loadMapAsset(dispatch, slug as string);
  }, [slug, dispatch, mapAssets]);

  const map = mapAssets[slug as string];

  return (
    <Layout>
      <Header />
        <div>
          { 
            !loading && map && <div className="">
              <div className="pb-4 text-center flex-col">
                <h1>{map.title}</h1>
                <p>{map.description}</p>
              </div>
              <TransformWrapper>
                {({ zoomIn, zoomOut, resetTransform }) => (
                  <>
                    <div className="flex-row text-center content-center">
                      <ControlButton onClick={() => zoomIn()} text="Zoom +" />
                      <ControlButton onClick={() => zoomOut()} text="Zoom -" />
                      <ControlButton onClick={() => resetTransform()} text="Reset" />
                    </div>
                    <TransformComponent>
                      <ReactSVG 
                        loading={() => <Loading isLoading/>}
                        src={map.map_svg_url} 
                      />
                    </TransformComponent>
                  </>
                )}
              </TransformWrapper>
            </div>
          }
        </div>
    </Layout>
  );
}

export default Map;

